const sliders = document.querySelectorAll('.product-grid-item__image--gallery');
if (!sliders.length) return;

const Flickity = themeVendor?.Flickity;

sliders.forEach((slider) => {
  const items = slider.querySelectorAll('.product__media');

  if (items.length > 1) {
    const sl = new Flickity(slider, {
      wrapAround: true,
      pageDots: false
    });
  }
});